import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import {
  fetchJewellersRequest,
  deleteJewellerRequest,
} from "../../../redux/JewellerList/JewellerSlice";
import TableCompo from "../Table/TableCompo";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { width } from "@mui/system";
import { Box} from "@mui/material";
import InfoButton from "../../Comman/InfoButton";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import { useState } from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import auth from "../../../configs/auth";
import useCsvConverter from "../../../hooks/convertToCSV";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import { canShowPermission } from "../Permissions/permissionObject";
import { useNavigate } from "react-router-dom";
import JewellerDocumentsDialog from "./JewellerDocumentsDialog";

const formatJewellerComments = (comment) => {
  const items = Array.isArray(comment)
    ? [...comment]
    : comment
    ? [comment]
    : [];

  return items
    .sort(
      (a, b) => (Number(b?.createdAt) || 0) - (Number(a?.createdAt) || 0)
    )
    .map((item) => {
      if (typeof item === "string") {
        return { text: item, time: "", userName: "-", userId: undefined };
      }
      return {
        text: item?.comment || "",
        time: item?.createdAt
          ? new Date(item.createdAt).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "",
        userId: item?.createdBy?._id,
        userName: item?.createdBy?.name || "-",
      };
    })
    .filter((item) => item.text);
};

const CreateJewellerTable = ({ refresh, onEdit, onDelete }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedJeweller, setSelectedJeweller] = useState(null);
  const [openCommentsDialog, setOpenCommentsDialog] = useState(false);
  const [selectedCommentsJeweller, setSelectedCommentsJeweller] =
    useState(null);
  const [openDocumentsDialog, setOpenDocumentsDialog] = useState(false);
  const [selectedDocumentJeweller, setSelectedDocumentJeweller] =
    useState(null);
  console.log("selectedJeweller", selectedJeweller);

  const {
    jewellers = [],
    total = 0,
    loading,
    message,
    messageType,
  } = useSelector((state) => state.jeweller || {});
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const jeweller = sessionStorage.getItem(auth.selectedJeweller);
  useEffect(() => {
    // dispatch(getActiveCountriesRequest({ jeweller }));
    dispatch(fetchJewellersRequest({ page: currentPage, limit, search }));
  }, [dispatch, currentPage, limit, search, refresh]);

  const handleTableChange = (action, payload) => {
    if (action === "changePage") {
      setCurrentPage(payload.page);
    } else if (action === "changeRowsPerPage") {
      setLimit(payload.rowsPerPage);
      setCurrentPage(payload.page);
    } else if (action === "search") {
      setSearch(payload.searchText);
      setCurrentPage(0);
    }
  };

  const handleDeleteClick = (storeId, status) => {
    toast(
      ({ closeToast }) => (
        <div
          style={{
            background: "#fff",
            padding: "16px 20px",
            borderRadius: "8px",
            boxShadow: "0px 2px 10px rgba(0,0,0,0.4)",
            color: "#000",
            fontSize: "14px",
            maxWidth: "300px",
          }}
        >
          <p>
            Are you sure you want to{" "}
            {status === "inactive" ? "enable" : "disable"} this jeweller?
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <button
              style={{
                background: "#8e5addff",
                color: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch(deleteJewellerRequest(storeId));
                toast.success(
                  `Jeweller ${
                    status === "inactive" ? "enabled" : "disabled"
                  } successfully!`
                );
                closeToast();
              }}
            >
              Yes
            </button>
            <button
              style={{
                background: "#9e9e9e",
                color: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={closeToast}
            >
              No
            </button>
          </div>
        </div>
      ),
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        style: {
          padding: 0,
          background: "none",
          boxShadow: "none",
        },
      }
    );
  };

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Invalid permissions JSON", e);
      }
    }
  }, []);
  const canEdit = canShowPermission(permissions, "jeweller", "edit");
  const canDelete = canShowPermission(permissions, "jeweller", "delete");
  const canViewJewellerDocuments = canShowPermission(
    permissions,
    "jewellerPermission",
    "view"
  );
  const columns = [
    { field: "_id", headerName: "ID", hideInExcel: true, width: 80 },
    { field: "jewellerName", headerName: " Name", width: 180 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    {
      field: "address1",
      headerName: "Address",
      width: 200,
      hideInExcel: true,
    },
    { field: "city", headerName: "City", width: 150, hideInExcel: true },
    {
      field: "currency",
      headerName: "Currency",
      width: 150,
      render: (value, row) =>
        Array.isArray(row?.fullData?.countryCode) &&
        row.fullData.countryCode.length > 0
          ? row.fullData.countryCode[0].currency || "N/A"
          : "N/A",
    },
    {
      field: "mobileNumberLength",
      headerName: "Mobile Number Length",
      width: 150,
      render: (value, row) =>
        Array.isArray(row?.fullData?.countryCode) &&
        row.fullData.countryCode.length > 0
          ? row.fullData.countryCode[0].phoneLength || "N/A"
          : "N/A",
    },
    // {
    //   field: "RM",
    //   headerName: "RM",
    //   width: 200,
    //   hideInExcel: true,
    //   render: (value, row) => {
    //     return Array.isArray(row?.fullData?.RM) && row.fullData.RM.length > 0
    //       ? row.fullData.RM.map((rm) => rm.name).join(" | ")
    //       : "N/A";
    //   },
    // },
    // {
    //   field: "directors",
    //   headerName: "Directors",
    //   width: 250,
    //   hideInExcel: true,
    //   render: (value, row) => {
    //     return Array.isArray(row?.directors)
    //       ? row.directors.map((d) => `${d.name}`).join(" | ")
    //       : "N/A";
    //   },
    // },
    {
      field: "Details",
      headerName: "RM Details",
      render: (val, row) => (
        <button
          style={{
            backgroundColor: "#ffc107",
            color: "#000",
            border: "none",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() => {
            const fullJeweller = jewellers.find((j) => j._id === row._id);
            setSelectedJeweller(fullJeweller);
            console.log("Full Jeweller selected:", fullJeweller);

            setOpenDialog(true);
          }}
        >
          View
        </button>
      ),
    },
    {
      field: "comment",
      headerName: "Comment",
      width: 140,
      hideInExcel: true,
      render: (val, row) => {
        const comments = formatJewellerComments(
          row?.comment || row?.fullData?.comment
        );
        return (
          <button
            style={{
              backgroundColor: "#ffc107",
              color: "#000",
              border: "none",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              const fullJeweller = jewellers.find((j) => j._id === row._id);
              setSelectedCommentsJeweller(fullJeweller || row);
              setOpenCommentsDialog(true);
            }}
          >
            {comments.length > 0 ? `View (${comments.length})` : "View"}
          </button>
        );
      },
    },
    ...(canViewJewellerDocuments
      ? [
          {
            field: "documents",
            headerName: "Document",
            width: 280,
            hideInExcel: true,
            render: (val, row) => {
              const fullJeweller =
                jewellers.find((j) => j._id === row._id) || row;
              const jewellerId =
                fullJeweller?._id || fullJeweller?.fullData?._id || row._id;
              const jewellerName =
                fullJeweller?.jewellerName ||
                fullJeweller?.fullData?.jewellerName ||
                row.jewellerName ||
                "";
              return (
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  <button
                    style={{
                      backgroundColor: "#752ADA",
                      color: "#fff",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSelectedDocumentJeweller(fullJeweller);
                      setOpenDocumentsDialog(true);
                    }}
                  >
                    Document
                  </button>
                  <button
                    style={{
                      backgroundColor: "#1a73e8",
                      color: "#fff",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate("/UploadJewellerDocument", {
                        state: { jewellerId, jewellerName },
                      })
                    }
                  >
                    Upload Document
                  </button>
                </Box>
              );
            },
          },
        ]
      : []),
    ...(canEdit
      ? [
          {
            field: "edit",
            headerName: "Edit",
            render: (value, row) => {
              const fullJeweller = jewellers.find((j) => j._id === row._id);
              console.log("fullJeweller", fullJeweller);
              return (
                <CiEdit
                  style={{ cursor: "pointer", color: "#1976d2" }}
                  onClick={() => onEdit(fullJeweller)}
                />
              );
            },
            hideInExcel: true,
          },
        ]
      : []),
    ...(canDelete
      ? [
          {
            field: "status",
            headerName: "Status",
            render: (value, row) => (
              <button
                style={{
                  backgroundColor:
                    row?.fullData?.status === "inactive"
                      ? "#e53935"
                      : "#43a047",
                  // inactive → red (Disable), active → green (Enable)
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleDeleteClick(row._id, row?.fullData?.status)
                }
              >
                {row?.fullData?.status === "inactive" ? "Disable" : "Enable"}
              </button>
            ),
            hideInExcel: true,
          },
        ]
      : []),
    {
      field: "createdBY",
      headerName: "Created By",
      width: 200,
      hideInExcel: true,
      render: (value, row) => {
        return row?.createdBy ? row.createdBy.name : "N/A";
      },
    },
    {
      field: "updatedBy",
      headerName: "Updated By",
      width: 200,
      hideInExcel: true,
      render: (value, row) => {
        return row?.updatedBy ? row.updatedBy.name : "N/A";
      },
    },
    {
      field: "createFollowup",
      headerName: "Create Followup",
      width: 170,
      hideInExcel: true,
      render: (val, row) => {
        const fullJeweller = jewellers.find((j) => j._id === row._id);
        return (
          <Button
            variant="contained"
            size="small"
            sx={{
              textTransform: "none",
              background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
            }}
            onClick={() =>
              navigate("/CreateFollowup", {
                state: {
                  type: "jeweller",
                  jewellerId: row._id,
                  jewellerRow: fullJeweller?.fullData || fullJeweller,
                },
              })
            }
          >
            Create Followup
          </Button>
        );
      },
    },
  ];
  const pdfColumnWidths = {
    id: 8,
    jewellerName: 30,
    email: 20,
    phone: 25,
    countryCode: 20,
    Area: 15,
    address1: 20,
    address2: 20,
    address3: 20,
    city: 15,
    state: 15,
    directors: 25,
    signatories: 25,
  };
  const { convertToCsv } = useCsvConverter();

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadStoreCsv = () => {
    console.log("Store CSV API called");

    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/jeweller/jewellerCsvData",
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "jeweller.csv");
        },
      })
    );
  };
  return (
    <div>
      <Box sx={{ position: "relative" }}>
        <TableCompo
          columns={columns}
          data={
            Array.isArray(jewellers)
              ? jewellers.map((row, index) => ({
                  ...row,
                  id: row._id || row.jeweller?._id || index,
                }))
              : []
          }
          pdfColumnWidths={pdfColumnWidths}
          totalCount={total}
          page={currentPage}
          limit={limit}
          loading={loading}
          onTableChange={handleTableChange}
          extraButtons={
            <Button
              size="sm"
              variant="outlined"
              onClick={handleDownloadStoreCsv}
            >
              Download CSV
            </Button>
          }
        />
      {messageType === "error" && (
        <p style={{ color: "red", marginTop: "10px" }}>{message}</p>
      )}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            position: "relative",
            background: "linear-gradient(135deg, #667eea, #764ba2)",
          }}
        >
          Company Details
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialog(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[300],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedJeweller && (
            <div>
              {/* <Typography variant="h6" gutterBottom>
                Jeweller Info
              </Typography> */}
              <Typography>
                <strong>Company Name:</strong>{" "}
                {selectedJeweller.fullData.jewellerName}
              </Typography>
              <Typography>
                <strong>Company Email:</strong>{" "}
                {selectedJeweller.fullData.email}
              </Typography>
              <Typography>
                <strong>Company Phone:</strong>{" "}
                {selectedJeweller.fullData.phone}
              </Typography>
              <Typography>
                <strong>Package (Android):</strong>{" "}
                {selectedJeweller.fullData.package_name || "—"}
              </Typography>
              <Typography>
                <strong>Package (iOS):</strong>{" "}
                {selectedJeweller.fullData.package_name_ios || "—"}
              </Typography>

              {Array.isArray(selectedJeweller.fullData?.address) &&
              selectedJeweller.fullData.address.length > 0 ? (
                selectedJeweller.fullData.address.map((addr, idx) => (
                  <div key={idx} mb={2}>
                    <Typography>
                      <strong>Address:</strong> {addr.address1} {addr.address2}{" "}
                      {addr.address3}
                    </Typography>
                    <Typography>
                      <strong>Area:</strong> {addr.Area}
                    </Typography>
                    <Typography>
                      <strong>City:</strong> {addr.city}
                    </Typography>
                    <Typography>
                      <strong>State:</strong> {addr.state}
                    </Typography>
                    <Typography>
                      <strong>Pincode:</strong> {addr.pincode}
                    </Typography>
                  </div>
                ))
              ) : (
                <Typography>No address data available</Typography>
              )}

              <Typography variant="h6" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
                Relationship Managers (RM)
              </Typography>

              {Array.isArray(selectedJeweller.fullData?.RM) &&
              selectedJeweller.fullData.RM.length > 0 ? (
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: 3,
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          background:
                            "linear-gradient(135deg, #667eea, #764ba2)",
                        }}
                      >
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                          Name
                        </TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                          Email
                        </TableCell>
                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                          Phone
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {selectedJeweller.fullData.RM.map((rm, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#fafafa" : "#ffffff",
                            "&:hover": {
                              backgroundColor: "#f0f4ff",
                            },
                          }}
                        >
                          <TableCell sx={{ fontWeight: 500 }}>
                            {rm.name}
                          </TableCell>
                          <TableCell sx={{ color: "#222121ff" }}>
                            {rm.email}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={rm.phone}
                              color="primary"
                              variant="outlined"
                              size="small"
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography color="text.secondary">No RM assigned.</Typography>
              )}

              {/* 
        {selectedJeweller.address?.map((addr, idx) => (
          <div key={idx} style={{ marginTop: 10 ,background:'red',height:'20px',width:'90px'}}>
            <Typography variant="subtitle1">Address {idx + 1}</Typography>
            <Typography>{addr.address1}, {addr.address2}, {addr.address3}</Typography>
            <Typography> {addr.pincode}</Typography>
          </div>
        ))} */}

              {/* Director Table */}
              {/* <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
                Director Details
              </Typography>
              {Array.isArray(selectedJeweller.fullData?.directors) &&
              selectedJeweller.fullData.directors.length > 0 ? (
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "16px",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Name
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Email
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Phone
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedJeweller.fullData.directors.map((dir) => (
                      <tr key={dir._id}>
                        <td
                          style={{ border: "1px solid #ccc", padding: "8px" }}
                        >
                          {dir.name}
                        </td>
                        <td
                          style={{ border: "1px solid #ccc", padding: "8px" }}
                        >
                          {dir.email}
                        </td>
                        <td
                          style={{ border: "1px solid #ccc", padding: "8px" }}
                        >
                          {dir.phone}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <Typography>No directors found.</Typography>
              )} */}

              {/* Signatory Table */}
              {/* <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
                Signatory Info
              </Typography> */}
              {/* {Array.isArray(selectedJeweller.fullData?.signatories) &&
              selectedJeweller.fullData.signatories.length > 0 ? (
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "16px",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Name
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Email
                      </th>
                      <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Phone
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedJeweller.fullData.signatories.map((sig) => (
                      <tr key={sig._id}>
                        <td
                          style={{ border: "1px solid #ccc", padding: "8px" }}
                        >
                          {sig.name}
                        </td>
                        <td
                          style={{ border: "1px solid #ccc", padding: "8px" }}
                        >
                          {sig.email}
                        </td>
                        <td
                          style={{ border: "1px solid #ccc", padding: "8px" }}
                        >
                          {sig.phone}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <Typography>No signatories found.</Typography>
              )} */}
            </div>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={openCommentsDialog}
        onClose={() => {
          setOpenCommentsDialog(false);
          setSelectedCommentsJeweller(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            position: "relative",
            background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
            color: "#fff",
          }}
        >
          Comments
          {selectedCommentsJeweller?.jewellerName
            ? ` — ${selectedCommentsJeweller.jewellerName}`
            : ""}
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenCommentsDialog(false);
              setSelectedCommentsJeweller(null);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {(() => {
            const comments = formatJewellerComments(
              selectedCommentsJeweller?.comment ||
                selectedCommentsJeweller?.fullData?.comment
            );
            if (!comments.length) {
              return (
                <Typography color="text.secondary">
                  No comments yet
                </Typography>
              );
            }
            return (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {comments.map((item, idx) => (
                  <Box
                    key={item.userId ? `${item.userId}-${idx}` : idx}
                    sx={{
                      p: 1.75,
                      borderRadius: "10px",
                      border: "1px solid #E5E7EB",
                      background: "#F9FAFB",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#6B7280",
                      }}
                    >
                      {item.userName}
                      {item.time ? ` • ${item.time}` : ""}
                    </Typography>
                    <Typography sx={{ mt: 0.5, fontSize: 14, color: "#111827" }}>
                      {item.text}
                    </Typography>
                  </Box>
                ))}
              </Box>
            );
          })()}
        </DialogContent>
      </Dialog>
      <JewellerDocumentsDialog
        open={openDocumentsDialog}
        jeweller={selectedDocumentJeweller}
        onClose={() => {
          setOpenDocumentsDialog(false);
          setSelectedDocumentJeweller(null);
        }}
      />
      <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="JEWELLER" />
  </Box>
      </Box>
    </div>
  );
};

export default CreateJewellerTable;
